"use client"
import styled from "@emotion/styled"
import "swiper/css"
import { Container, NewText } from "ui"
import ImageWithAlt from "ui/ImageWithAlt"
import { extractImage, extractProperty } from "utils"

const StyledContainer = styled.div`
  margin-top: 32px;
  background: white;
  div {
    ul {
      padding-left: 30px;
      li {
        list-style: disc;
      }
    }
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    margin-top: 40px;
  }
`
type Props = {
  data: any
}

export const IconTitleTextContent: React.FC<Props> = ({ data }) => {
  const icon = extractImage(data, "icon")
  const title = extractProperty(data, "title")
  const innerText = extractProperty(data, "content")
  return (
    <Container>
      <StyledContainer>
        <ImageWithAlt
          image={icon}
          width={32}
          height={32}
          style={{ objectFit: "contain" }}
          role="presentation"
          aria-hidden="true"
        />
        <NewText
          desktopFontSize={32}
          desktopFontWeight="400"
          desktopLineHeight="36px"
          mobileFontSize={24}
          mobileFontWeight="400"
          mobileLineHeight="28px"
          component="h2"
          color={"black"}
        >
          {title}
        </NewText>
        <NewText
          desktopFontSize={18}
          desktopFontWeight="400"
          desktopLineHeight="26px"
          mobileFontSize={16}
          mobileFontWeight="400"
          mobileLineHeight={"23px"}
          component="div"
          color={"black"}
          dangerouslySetInnerHTML={{ __html: innerText }}
          maxWidth="800px"
          style={{ marginBlockStart: 16, marginBlockEnd: 40 }}
        />
      </StyledContainer>
    </Container>
  )
}
export default IconTitleTextContent
